import { TemplateResult, html, CSSResultGroup } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { OutlineElement } from '../../base/outline-element/outline-element';
import componentStyles from './tufts-icon-with-paragraph.css.lit';
import { classMap } from 'lit-html/directives/class-map.js';
import { SlotNGController } from '../../controllers/slot-ng-controller';
import tuftsHeadingCssLit from '../tufts-heading/tufts-heading.css.lit';
import tuftsStyleTextStyles from '../tufts-styled-text/tufts-styled-text.css.lit';

/**
 * The Tufts Card Icon Callout component
 * @element tufts-icon-with-paragraph
 *
 * @slot icon
 * @slot heading
 * @slot description
 * @slot cta
 *
 * @attr show-border
 * @attr card-version
 * @attr heading-size
 */

@customElement('tufts-icon-with-paragraph')
export class tuftsIconWithParagraph extends OutlineElement {
  static styles: CSSResultGroup = [
    componentStyles,
    tuftsHeadingCssLit,
    tuftsStyleTextStyles,
  ];
  ngSlot = new SlotNGController(this);
  @property({ type: Boolean, reflect: true }) showBorder = false;

  @property({ type: Boolean, reflect: true, attribute: 'card-version' })
  cardVersion = false;

  @property({ type: Boolean, reflect: true, attribute: 'align-icon-text' })
  alignIconText = false;

  @property({ type: String, reflect: true, attribute: 'heading-size' })
  headingSize = 'xl';

  render(): TemplateResult {
    const classes = {
      'with-border': this.showBorder,
      'card-border': this.cardVersion,
      'align-icon-text': this.alignIconText,
    };
    return html`
      <section class=" ${classMap(classes)} ">
        ${this.ngSlot.conditionalNGSlot('icon')}
        ${this.ngSlot.conditionalNGSlot('heading', true, this.headingSize)}
        ${this.ngSlot.conditionalNGSlot('description')}
        ${this.ngSlot.conditionalNGSlot('cta')}
      </section>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'tufts-icon-with-paragraph': tuftsIconWithParagraph;
  }
}
